import {useEffect, useState } from 'react'

const useApiRequest = url => {
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(null);
  const [error, setError] = useState(null);
  const apiToken = process.env.REACT_APP_API_TOKEN


  useEffect(() =>{
     setIsLoaded('loading . . ');
     const timer = setTimeout(() => {
     setError(null);
     fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
        'Authorization': apiToken,
      } }
      )
     .then((response) => {
       return response.json();
     } )
     .then((content) =>{
       setIsLoaded(false);
       setData(content);
     })
     .catch(error =>{
      setError(error,'An error occurred. Awkward..')
     })
    }, 1400);
    return () => clearTimeout(timer);

   }, [url, apiToken]);
   return{
     data, isLoaded, error
   }

 }

export default useApiRequest;